import React from "react"
import autobind from "class-autobind"
import { IScheduleBudgetDay } from "../../../../../models/data/scheduling/ScheduleBudgetDay"
import { Paper, FontIcon } from "material-ui"
import { green500, red500 } from "material-ui/styles/colors"
import * as scheduleHelper from "../../../../../helpers/scheduleHelper"
import * as colorHelper from "../../../../../helpers/colorHelper"
import WorkInstructions from "../../../../../components/work_instructions/WorkInstructions"
import AccountStore from "../../../../../stores/AccountStore"

interface IProps {
  scheduleBudgetDay: IScheduleBudgetDay
  handleUpdateDailyBudget(dailyBudget: IScheduleBudgetDay, dayIndex: number): void
}
interface IState {
  selectedDay: number
}

export default class ScheduleResourcePlannerItemBudgetSummary extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      selectedDay: 0,
    }
    autobind(this)
  }

  getVarianceColor(variance: number) {
    if (variance == 0) {
        return null
    } else if (variance > 0) {
        return green500
    } else {
        return red500
    }
}

  getVarianceIcon(variance: number) {
      if (variance == 0) {
          return null
      } else if (variance > 0) {
          return (
              <FontIcon className="fa fa-arrow-up" style={{ fontSize: 12, color: green500 }} />
          )
      } else {
          return (
              <FontIcon className="fa fa-arrow-down" style={{ fontSize: 12, color: red500 }} />
          )
      }
  }



  render() {
    let showSingleUnit = scheduleHelper.isSingleBudgetVolumeUnit(this.props.scheduleBudgetDay.BudgetPositions) 
    let columnOffset = showSingleUnit ? -2 : 0

    return (
        <Paper style={{marginTop: 10, marginBottom: 20, padding: 10, borderRadius: 10}}>
          <div style={{display: "grid"}}>
            {!showSingleUnit && 
              <div style={{gridRow: 1, gridColumn: 1+columnOffset, fontSize: 10, paddingLeft: 5}}>
                Unit
              </div>
            }
            {!showSingleUnit && 
              <div style={{gridRow: 1, gridColumn: 2+columnOffset, fontSize: 10, paddingLeft: 5}}>
                Volume
              </div>
            }
            <div style={{gridRow: 1, gridColumn: 3+columnOffset, fontSize: 10, paddingLeft: 5}}>
              Position
            </div>
            <div style={{gridRow: 1, gridColumn: 4+columnOffset, fontSize: 10, paddingLeft: 5}}>
              Budgeted Staff
            </div>
            <div style={{gridRow: 1, gridColumn: 5+columnOffset, fontSize: 10, paddingLeft: 5}}>
              Filled
            </div>
            <div style={{gridRow: 1, gridColumn: 6+columnOffset, fontSize: 10, paddingLeft: 5}}>
              Variance
            </div>

            {!showSingleUnit && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
                <div key={index} style={{
                    gridColumn: 1+columnOffset, 
                    gridRow: index+2, 
                    color: colorHelper.getBudgetUnitColor(row), 
                    backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)),
                    paddingLeft: 3, 
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    paddingRight: 5,
                    }}>
                  {row.Unit && row.Unit.UnitName}
                </div>
            )}

            {!showSingleUnit && this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
                <div key={index} style={{gridColumn: 2+columnOffset, gridRow: index+2, paddingLeft: 5, color: colorHelper.getBudgetUnitColor(row), backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row))}}>
                  {row.DemandUnits}
                </div>
            )}    

            {this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
                <div key={index} style={{
                    gridColumn: 3+columnOffset, 
                    gridRow: index+2, 
                    color: colorHelper.getBudgetUnitColor(row), 
                    backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row)),
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    paddingRight: 5, paddingLeft: 5,
                    }}>
                  {row.Unit && row.Unit.PositionName}
                </div>
            )}

            {this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
                <div key={index} style={{gridColumn: 4+columnOffset, gridRow: index+2, paddingLeft: 5, paddingRight: 5,color: colorHelper.getBudgetUnitColor(row), backgroundColor: scheduleHelper.getTransparentBackgroundColor(colorHelper.getBudgetUnitColor(row))}}>
                  {row.BudgetedNumber}
                </div>
            )}            

            {this.props.scheduleBudgetDay.BudgetPositions.map((row, index) =>
                <div key={index} style={{gridColumn: 5+columnOffset, gridRow: index+2, paddingLeft: 5, paddingRight: 5, color: colorHelper.getBudgetUnitColor(row), 
                  background: scheduleHelper.getTransparentBackgroundColorFade(colorHelper.getBudgetUnitColor(row), "#ffffff")
                  }}>
                  {row.FilledShifts}
                </div>
            )}            

            {this.props.scheduleBudgetDay.BudgetPositions.map((row, index) => {

              return (
                  <div key={index} style={{gridColumn: 6+columnOffset, gridRow: index+2, paddingRight: 5, color: this.getVarianceColor(row.Variance), paddingLeft: 10}}>
                    {row.Variance > 0 && "+"}{row.Variance} {this.getVarianceIcon(row.Variance)}
                  </div>
                )
            })}            
          </div>

          {AccountStore.getEnableWorkInstructions() && 
            <WorkInstructions 
              readonly={false}
              scheduleBudgetDay={this.props.scheduleBudgetDay}
              update={(updateDayData) => {
                this.props.handleUpdateDailyBudget(updateDayData, this.state.selectedDay)
              }}
            /> 
          }                     
        </Paper>
    )
  }
}